"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFilter = void 0;
var _get_time = _interopRequireDefault(require("date-fns/get_time"));
var _is_within_range = _interopRequireDefault(require("date-fns/is_within_range"));
var _is_date = _interopRequireDefault(require("date-fns/is_date"));
var _get = _interopRequireDefault(require("lodash/get"));
var _add_days = _interopRequireDefault(require("date-fns/add_days"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var dateFilter = exports.dateFilter = function dateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var timeStamp = arguments.length > 3 ? arguments[3] : undefined;
  var rawTimeStamp = (0, _get["default"])(item, timeStamp);
  if (!rawTimeStamp) {
    console.warn("order history item does not have a ".concat(timeStamp, " property:"), item);
    return false;
  }
  if ((0, _is_date["default"])(startDate) && (0, _is_date["default"])(endDate)) {
    return (0, _is_within_range["default"])(rawTimeStamp, (0, _get_time["default"])(startDate), (0, _get_time["default"])((0, _add_days["default"])(endDate, 1)));
  }
  return (0, _is_within_range["default"])(rawTimeStamp, 0, Date.now());
};